import { FORM_SLUG } from "../form-config";
import type { FormValues } from "../types";

const DEFAULT_WEBHOOK_URL =
  "https://script.google.com/macros/s/AKfycbwNzJeJWt4IfwQmnee3l9DZw07jLWb060Gf01RxrSpY8nWjNCt3OnP06e6DfWPJt3OP/exec";

const WEBHOOK_URL =
  (import.meta.env.VITE_SHEETS_WEBHOOK_URL as string | undefined) || DEFAULT_WEBHOOK_URL;

/**
 * POSTs the completed application to a Google Apps Script Web App which
 * appends a row to the Upside intake sheet. See docs/google-sheets-setup.md
 * for the script source and deployment recipe.
 *
 * The Content-Type is text/plain (not application/json) so the browser does
 * not send a CORS preflight — Apps Script Web Apps do not respond to OPTIONS.
 * The script parses the JSON body server-side.
 */
export async function submitApplication(
  values: FormValues,
): Promise<{ ok: true } | { ok: false; reason: string }> {
  const payload = { formSlug: FORM_SLUG, values };

  try {
    const response = await fetch(WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(payload),
      redirect: "follow",
    });

    if (!response.ok) {
      return { ok: false, reason: `Upstream responded ${response.status}` };
    }

    const result = (await response.json()) as { ok: boolean; reason?: string };
    if (!result.ok) {
      return { ok: false, reason: result.reason ?? "Upstream rejected the submission" };
    }
    return { ok: true };
  } catch (err) {
    return { ok: false, reason: err instanceof Error ? err.message : "Network error" };
  }
}
